import { render } from "./VendorStatus.vue?vue&type=template&id=4b33b55c&scoped=true"
import script from "./VendorStatus.vue?vue&type=script&lang=js"
export * from "./VendorStatus.vue?vue&type=script&lang=js"

import "./VendorStatus.vue?vue&type=style&index=0&id=4b33b55c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b33b55c"]])

export default __exports__